module.exports = __webpack_public_path__ + "img/beer_id-4.2e7129a5.jpg";